import {produce} from 'immer';
import {useStoreState} from 'store';
import {AdditionalFilter, AllFields} from 'entities/chartFilters';
import {DummyStorySlug} from 'views/storyboard/stores/activeDummyStory';
import {ChartFilterType} from 'views/storyboard/utils/chartConstants';
import {STORY_OBJECT_TYPE_MAP} from '@/views/storyboard/types';

const addStoryObjectField = (
    allFields: AllFields,
    activeStoryObject: string,
    activeDummyStorySlug: DummyStorySlug | '',
): AllFields => {
    if (!activeStoryObject || !activeDummyStorySlug) {
        return allFields;
    }

    return produce(allFields || {}, (draft) => {
        draft[STORY_OBJECT_TYPE_MAP[activeDummyStorySlug]] = [{
            value: activeStoryObject,
            label: activeStoryObject,
        }];
    });
};

const addStoryObjectFilter = (
    additionalFilters: AdditionalFilter[],
    activeStoryObject: string,
    activeDummyStorySlug: DummyStorySlug | '',
): AdditionalFilter[] => {
    if (!activeStoryObject || !activeDummyStorySlug) {
        return additionalFilters;
    }

    return produce(additionalFilters || [], (draft) => {
        draft.push({
            value: `all_fields.${STORY_OBJECT_TYPE_MAP[activeDummyStorySlug]}`,
            label: STORY_OBJECT_TYPE_MAP[activeDummyStorySlug],
            type: ChartFilterType.ComputedClassification,
        });
    });
};

const useGlobalFiltersCombined = (): [AllFields, AdditionalFilter[]] => {
    // Returns global filters that have the story object included in the filter where required
    const globalFilterAllFields = useStoreState((state) => state.search.searchQueryAllFields);
    const globalFilterAdditionalFilters = useStoreState((state) => state.search.searchQueryAdditionalFilters);

    const activeStoryObject = useStoreState((state) => state.activeStoryObject.activeStoryObject);
    const activeDummyStorySlug = useStoreState((state) => state.activeDummyStory.activeDummyStorySlug);

    const globalAllFields = addStoryObjectField(globalFilterAllFields, activeStoryObject, activeDummyStorySlug);
    const globalAdditionalFilters = addStoryObjectFilter(
        globalFilterAdditionalFilters,
        activeStoryObject,
        activeDummyStorySlug,
    );

    return [globalAllFields, globalAdditionalFilters];
};

export default useGlobalFiltersCombined;
